import { createContext, useMemo, useContext, useState, useCallback } from "react";

const GlobalStates = createContext(undefined);

const getStoredUserDetails = () => {
    try {
        const stored = localStorage.getItem('avaco_user_details');
        return stored ? JSON.parse(stored) : {};
    } catch {
        return {};
    }
};

export const GlobalValues = ({children}) => {

    const [userDetails, setUserDetailsState] = useState(getStoredUserDetails)

    const setUserDetails = useCallback((details) => {
        setUserDetailsState(details);
        if (details && Object.keys(details).length > 0) {
            localStorage.setItem('avaco_user_details', JSON.stringify(details));
        } else {
            localStorage.removeItem('avaco_user_details');
        }
    }, []);

    const values = useMemo(() => (
        { userDetails, setUserDetails }
    ), 
    [userDetails, setUserDetails]);

    return <GlobalStates.Provider value={values}>{children}</GlobalStates.Provider>
}

export const useGlobalValues = () => {
    const context = useContext(GlobalStates);
    if (context === undefined) {
      throw new Error(
        "GlobalStates must be used within a GlobalValues"
      );
    }
    return context;
};